module.exports = __webpack_public_path__ + "img/milieuzones.1ba2b9a1.jpg";